<template>
    <form
        method="get"
        accept-charset="utf-8"
        name="header_search"
        class="autocomplete-form"
        :action="autocompleteUrl"
        v-on:submit.prevent="search"
    >
        <div class="autocomplete-form__container">
            <input
                type="text"
                :id="'autocomplete-' + parseInt(Math.random() * 1000)"
                class="autocomplete-form__input"
                v-model="keyword"
                name="search"
                autocomplete="off"
                :placeholder="placeholder"
                @input="search"
            />

            <button
                class="autocomplete-form__submit"
                :href="'/vyhladavanie?search=' + keyword"
                type="submit"
            >
                <i aria-hidden="true" class="ico ico-search"></i>
            </button>

            <button type="button" class="autocomplete-form__close">
                <i aria-hidden="true" class="ico ico-close"></i>
            </button>
        </div>
    </form>
</template>

<script>
import client from './../../../common/client';
import { CancelToken } from 'axios';

export default {
    props: {
        autocompleteUrl: {
            type: String,
            default: '/search/autocomplete',
        },
        placeholder: {
            type: String,
            default: 'Search',
        },
        limit: {
            type: Number,
            default: 3,
        },
    },
    data() {
        return {
            keyword: new URL(window.location.href).searchParams.get('search'),
            categoryId: null,
            cancelToken: null,
            isLoading: false,
        };
    },
    methods: {
        search() {
            this.$emit('input', this.keyword);

            // if is input too short
            if (this.limit > this.keyword.length + 1) {
                return false;
            }

            // cancel request
            if (this.cancelToken) {
                this.cancelToken.cancel();
            }

            this.cancelToken = CancelToken.source();

            this.isLoading = true;

            // request
            client
                .get(this.autocompleteUrl, {
                    params: {
                        limit: this.limit,
                        search: this.keyword,
                        category_id: this.categoryId,
                        // get: this.data.getModels.length > 0 ? this.data.getModels : []
                    },
                    cancelToken: this.cancelToken.token,
                })
                .then(response => {
                    this.$emit('searched', this.keyword, response.data);
                    this.isLoading = false;
                })
                .catch(error => {
                    if (!client.isCancel(error)) {
                        this.isLoading = false;
                    }
                });
        },
    },
    watch: {
        isLoading(value) {
            this.$emit('loading', value);
        },
    },
};
</script>
